<template>
  <section class="h_01" id="home">
    <m-img src="@/v2/mobile/assets/image/h_01.jpg"></m-img>
    <VideoMask :videoSrc="videoSrc">
      <m-img
        class="video_play"
        src="@/v2/mobile/assets/image/video_play.svg"
        poster="@/v2/mobile/assets/video/poster/v_0.webp"
      ></m-img>
    </VideoMask>
  </section>
</template>
<script>
import VideoMask from '@/components/video-mask.vue'
import videoSrc from '@/v2/mobile/assets/video/v_0.mp4'
export default {
  components: {
    VideoMask,
  },
  data() {
    return {
      videoSrc,
      preload_: true,
    }
  },
}
</script>
<style lang="less" scoped>
.h_01 {
  position: relative;
  .video_play {
    position: absolute;
    bottom: 6%;
    left: 0;
    right: 0;
    margin: auto;
    width: 40%;
    z-index: 1;
  }
}
</style>
